import React from "react";
import { SocialReactionFilterInput } from "../../../../Utilities";
import * as UserComponents from "../../User";

export type UsersListModalControllerProps = Omit<UserComponents.ControlledUsersListModalControllerProps, "filters"> & {
	filters?: SocialReactionFilterInput | null;
};

export function UsersListModalController({ filters, heading = "Likes", ...props }: UsersListModalControllerProps) {
	const userFilters = React.useMemo(() => ({ authoredSocialReactions: filters ? [filters] : undefined }), [filters]);

	return <UserComponents.ControlledUsersListModalController filters={userFilters} heading={heading} {...props} />;
}
